import { Avatar, Box, Button, Group, Stack, Title } from "@mantine/core";
import { IconPrinter } from "@tabler/icons-react";
import { useRef } from "react";
import ReactToPrint from "react-to-print";
import { Board } from "../../common/boards/board.schema";
import { Event } from "../../common/events/event.schema";

import PrintFooter from "../print/PrintFooter";
import PoolResultsTable from "./PoolResultsTable";

const PrintPoolResultsTable = ({
  disabled,
  event,
  board,
  debug,
}: {
  disabled?: boolean;
  debug?: boolean;
  event: Event;
  board: Board;
}) => {
  const componentRef = useRef<any>();
  // console.log("activeMembers :", activeMembers);

  // console.log("displayRows :", displayRows);
  const image = event.image || board.image;

  // return <></>;
  return (
    <>
      <ReactToPrint
        trigger={() => (
          <Button
            leftSection={<IconPrinter size={15} />}
            variant="subtle"
            disabled={disabled}
            size="xs"
          >
            Print pool results
          </Button>
        )}
        content={() => componentRef.current || null}
      />
      <div style={{ display: debug ? "block" : "none" }}>
        <Stack align="center" ref={componentRef} py={20} px={20}>
          <Stack align="center">
            <Group>
              {image && <Avatar src={image} />}
              <Title ta="center">{board.name}</Title>
            </Group>
            <Title order={2} ta="center">
              {event.name}
            </Title>
            <Title order={3} ta="center">
              Pool results
            </Title>
          </Stack>
          <Box w="100%">
            <PoolResultsTable event={event} />
          </Box>
          <PrintFooter />
        </Stack>
      </div>
    </>
  );
};
export default PrintPoolResultsTable;
